import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUpSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowUpSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7.68945 11L8.75 12.0605L11.25 9.56055V17H12.75V9.56055L15.25 12.0605L16.3105 11L12 6.68945L7.68945 11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowUpSquare;
